module.exports = __webpack_public_path__ + "static/img/007_TO8_1499.d8a5569.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/007_TO8_1499.jpg
// module id = 5VIK
// module chunks = 0